import '../CsvJsonInfoPages.scss';


function Ranges() {

    const data = [
        { field: 1, description: 'Range Code (Int)' },
        { field: 2, description: 'Range Name (Char)' },
        { field: 3, description: 'Manufacturer Code (Int)' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Ranges</h1>
            <p>Provides a list of Model Ranges coded by CAP.<br /><br/>
                CAP Vehicles are split into the following sections:<br /><br/>
                Manufacturer e.g. FORD<br/>
            <b>Model Range e.g. MONDEO</b><br/>
                Model e.g. MONDEO SALOON<br />
                Derivative e.g. ZETEC 4DR<br />
                Trim e.g. ZETEC
            </p>

            <b>File Naming Convention</b><br />

            <p>
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_CAPRange.txt<br />
                LIGHTS_yyyy-mm-dd_CAPRange.txt<br />
                HEAVIES_yyyy-mm-dd_CAPRange.txt<br />
                BIKES_yyyy-mm-dd_CAPRange.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Ranges;
